import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { MulticheckStore } from '../Store';
import { SelectionId } from '../Types';

interface Props<T> {
  store: MulticheckStore<T>;
  object: T;
  id: SelectionId;
  ariaLabel?: string;
}

function MulticheckInput<T>({ store, object, id, ariaLabel }: Props<T>) {
  useEffect(() => {
    store.addOption(object, id);
    return () => store.removeOption(id);
  }, [store, object, id]);

  const isChecked = store.isSelected(id);

  return (
    <input
      className="h-5 w-5 cursor-pointer text-teal-600 rounded-sm"
      type="checkbox"
      name="modifyParticipant"
      checked={isChecked}
      onChange={() => (isChecked ? store.deselect(id) : store.select(id))}
      aria-label={ariaLabel}
    />
  );
}

export default observer(MulticheckInput);
